import { useCheckoutRouting } from "@/hooks/useCheckoutRouting";
import { useCocoRate } from "@/hooks/useCocoRate";
import { formatEur, formatXpf } from "@/components/XpfPrice";

interface TamaPriceProps {
  /** Prix du catalogue TAMA, exprimé en Coco. */
  cocoAmount: number;
  className?: string;
  /** Affiche les équivalents F CFP et € (désactivé sur les cartes marketplace). */
  showEquivalents?: boolean;
}

/**
 * Prix d'un produit du catalogue TAMA : Coco (devise d'achat)
 * + équivalents F CFP (coco_rate) et € (xpf_per_eur) si showEquivalents.
 */
export const TamaPrice = ({ cocoAmount, className = "", showEquivalents = true }: TamaPriceProps) => {
  const { routing } = useCheckoutRouting();
  const cocoRate = useCocoRate();

  const amountXpf = cocoRate > 0 ? cocoAmount / cocoRate : null;
  const amountEur = amountXpf !== null ? amountXpf / routing.xpfPerEur : null;

  return (
    <div className={`flex flex-col gap-0.5 ${className}`}>
      <span className="font-semibold text-lg whitespace-nowrap">
        {cocoAmount.toLocaleString("fr-FR")} Coco
      </span>
      {showEquivalents && amountXpf !== null && amountEur !== null && (
        <span className="text-xs text-muted-foreground whitespace-nowrap">
          ≈ {formatXpf(amountXpf)} · {formatEur(amountEur)}
        </span>
      )}
    </div>
  );
};

export default TamaPrice;
